<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                <div class="question-block">
                    <div class="question">
                        Яке у пацієнта значення IPS? 
                    </div>
                    <div class="answers">
                        <div class="answer" :class="iPS === 'IPS 0-1 (низький)' ? 'active' : ''" @click="iPS = 'IPS 0-1 (низький)'">
                            <input type="radio" id="0-1" name="iPS" v-model="iPS" value="IPS 0-1 (низький)" required>
                            <label for="0-1"><strong>0-1 </strong>(низький)</label>
                        </div>
                        <div class="answer" :class="iPS === 'IPS 2-3 (середній)' ? 'active' : ''" @click="iPS = 'IPS 2-3 (середній)'">
                            <input type="radio" id="2-3" name="iPS" v-model="iPS" value="IPS 2-3 (середній)" required>
                            <label for="2-3"><strong>2-3 </strong>(середній)</label>
                        </div>
                        <div class="answer" :class="iPS === 'IPS 4-7 (високий)' ? 'active' : ''" @click="iPS = 'IPS 4-7 (високий)'">
                            <input type="radio" id="4-7" name="iPS" v-model="iPS" value="IPS 4-7 (високий)" required>
                            <label for="4-7"><strong>4-7 </strong>(високий)</label>
                        </div>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../../../components/Doctor/ErrorBlock';
import { mapMutations, mapGetters } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        iPS : '',
    }),
    computed : {
        ...mapGetters([
            'getIPS'
        ])
    },
    methods : {
        ...mapMutations([
            'setIPS',
        ])
    },
    created(){
        this.iPS = this.getIPS;
    },
    watch : {
        iPS : function(value){
            this.setIPS(value);
        }
    }
}
</script>

<style lang="scss" scoped>
.stage{
    .questions-wrapper{
        width: 325px;
        height: 305px;

        .questions-block{
            padding: 20px 40px;

            .question-block{
                .question{
                    font-size: 26px;
                }

                .answers{
                    padding-bottom: 0;

                    .answer{
                        width: 65%;

                        label{
                            font-size: 12px;
                            font-weight: 300;

                            strong{
                                padding-right: 3px;
                                font-size: 14px;
                            }
                        }
                    }

                    .answer:nth-child(2n){
                        margin-left: 0;
                    }
                }
            }           
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 40vw;
            height: auto;

            .questions-block{
                padding: 3.125vw 3.333vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                    }

                    .answers{

                        .answer{
                            width: 45%;

                            label{
                                font-size: 0.95vw;

                                strong{
                                    font-size: 1.042vw;
                                }
                            }
                        }
                    }
                }           
            }        
        }
    }
}

@media (max-width: 599px){
    .stage{
        .questions-wrapper{
            width: 100%;
            height: auto;

            .questions-block{
                padding: 5.556vw 5.278vw 6.667vw 5.556vw;

                .question-block{
                    .question{
                        font-size: 5.556vw;
                    }

                    .answers{
                        .answer{
                            label{
                                font-size: 3.889vw;

                                strong{
                                    padding-right: 3px;
                                    font-size: 4vw;
                                }
                            }
                        }

                        .answer:nth-child(2n){
                            margin-left: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>